import { Component, Input } from "@angular/core"
import { LearningObject } from "../../models/learningObject.model"
import { UserService } from "../../services/user.service"

@Component({
    selector: "app-card",
    template: "",
})
export class CardComponent {
    @Input("show-subject") public showSubject: boolean = false
    @Input("show-as-collection") public showAsCollection: boolean = false
    @Input() public learningObject: LearningObject = null
    @Input() public gtmPrefix: string = ""
    public placeholderImg: string = null

    constructor(public userService: UserService) {
        this.placeholderImg = require("../../../assets/placeholder-image.svg").default
    }

    public getAbsoluteUrl() {
        return this.learningObject.canonicalUrl
    }

    public getSubjectClass() {
        return `card-subject gtm-${this.gtmPrefix}-subject`
    }

    public getResourceBodyClass() {
        return `gtm-${this.gtmPrefix}-resource-body`
    }
}
